import React, {FC} from "react";
import {Box} from "@material-ui/core";
import Avatar from "view/components/Avatar";
import useLocalizedLocalMap from "hooks/useLocalizedLocalMap";

import FlexBox from "view/components/Layout/FlexBox";
import {
  AditusType,
  AspType,
  ExhibitorUserConnectionType,
  ExpoPlatformType,
  IExhibitorPair,
  IExhibitorUserConnection,
  IShow,
  SitkaType,
  VisitType,
} from "@evennt-tech/api-v2-core";
import SettingsButton from "view/components/SettingsButton";
import useJetSsoLink from "hooks/useJetSsoLink";
import useViewMode from "store/viewMode/viewMode.store";
import useCurrentSupplierCompanyId from "hooks/useCurrentSupplierCompanyId";
import SupplierNotification from "view/components/AppBar/components/NotificationsPopup/SupplierNotification";
import SwitchApp from "../../SwitchApp";
import UserActions from "../../UserActions";
import useStyles from "../styles";
import UserFullName from "../../UserFullName";

type Props = {
  show: IShow;
  fullName: string;
  isExhibitor: boolean;
  exhibitorPair?: IExhibitorPair | null;
  exhibitorConnection?: IExhibitorUserConnection | null;
  role: string;
  isWhiteColor: "" | "white" | undefined;
};

const UserDeatils: FC<Props> = ({
  show,
  fullName,
  isExhibitor,
  exhibitorPair,
  exhibitorConnection,
  role,
  isWhiteColor,
}) => {
  const classes = useStyles({show});
  const localMap = useLocalizedLocalMap(show, exhibitorPair?.stand?.builder);

  const showASPConfig = show.asp?.type === AspType.Pushing;

  const showAditusConfig =
    show.aditus?.type === AditusType.Pushing &&
    (!exhibitorConnection?.contractorCompanyName ||
      exhibitorConnection?.role === ExhibitorUserConnectionType.PRIMARY);

  const showButtonForSitka =
    show?.sitka?.type === SitkaType.SSO &&
    (!exhibitorConnection?.contractorCompanyName ||
      exhibitorConnection?.role === ExhibitorUserConnectionType.PRIMARY);

  const showButtonForVisit =
    show?.visit?.type === VisitType.Pushing &&
    (!exhibitorConnection?.contractorCompanyName ||
      exhibitorConnection?.role === ExhibitorUserConnectionType.PRIMARY);

  const showButtonForExpoPlatform =
    show?.expoPlatform?.type === ExpoPlatformType.Pushing;

  // Gated on the pair having a magic link, not on the show payload. No
  // contractor/role guard — the JET link works for every user on the pair.
  // Skipped in view-only mode (organiser "preview as exhibitor"): exhibitorPair
  // there is a mocked stand-in with no real backing session, so requesting its
  // SSO link would 403 against the Jet API's Roles.EXHIBITOR guard.
  const isViewOnly = useViewMode((state) => state.isViewOnly);
  const [jetSsoLink] = useJetSsoLink(
    show.id,
    isViewOnly ? undefined : exhibitorPair?.id
  );

  const supplierCompanyId = useCurrentSupplierCompanyId();

  const shouldShowSwitchAppButton =
    isExhibitor &&
    (showASPConfig ||
      showButtonForVisit ||
      showButtonForExpoPlatform ||
      showButtonForSitka ||
      showAditusConfig ||
      !!jetSsoLink);
  return (
    <FlexBox alignCenter className={classes.sideRight}>
      {shouldShowSwitchAppButton && (
        <SwitchApp headerBackground={!!show?.branding?.bannerImage?.url} />
      )}
      {role === "supplier" && supplierCompanyId && (
        <Box className={classes.notification}>
          <SupplierNotification
            supplierCompanyId={supplierCompanyId}
            iconColor={isWhiteColor || undefined}
          />
        </Box>
      )}
      <Box className={classes.sideText}>
        <UserFullName fullName={fullName} className={classes.fullName} />
        <Box className={classes.roleLabel}>
          {isExhibitor ? localMap.exhibitor : role}
        </Box>
      </Box>
      <Avatar
        name={fullName}
        alt={fullName}
        className={classes.avatar}
        showFallback
      />
      {isExhibitor && <SettingsButton iconColor={isWhiteColor || undefined} />}
      <UserActions iconColor={isWhiteColor} />
    </FlexBox>
  );
};

export default UserDeatils;
